// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ad-apply .van-field__control{text-indent:70px}.ad-apply .van-field__label{text-align:left;font-weight:600}.ad-apply .van-uploader__upload{background-color:#ccc}.ad-apply .van-uploader{position:static}.ad-apply .van-dialog__message{font-size:14px}.ad-apply .ad-request{margin-bottom:20px;border:1px solid #eaeaea}.ad-apply .ad-request .van-field__control{text-indent:10px}.ad-apply .ad-request .van-cell:first-of-type{padding-top:0}", ""]);
// Exports
module.exports = exports;
